import fetchApi from './api';
import {ApiResponse, SearchPaging} from 'models/model';

export const PartnerSave = async (data: any): Promise<ApiResponse> => {
    return fetchApi<ApiResponse>('/Partner/Save', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

export const PartnerGetPaging = async (data: SearchPaging): Promise<ApiResponse> => {
    return fetchApi<ApiResponse>('/Partner/GetPaging', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

export const PartnerGet = async (id: string): Promise<ApiResponse> => {
    return fetchApi<ApiResponse>('/Partner/Get', {
        method: 'POST',
        body: JSON.stringify({ id })
    });
};

export const PartnerDelete = async (id: string): Promise<ApiResponse> => {
    return fetchApi<ApiResponse>('/Partner/Delete', {
        method: 'POST',
        body: JSON.stringify({ id })
    });
};